<!--
    描述：角色管理
    日期：2021/04/08
    作者：zwh
-->
<template>
    <div class="h100">
        <w-split v-model="splitValueL">
            <div class="h100" slot="left">
                <roleTreeTable
                    ref="roleTreeTable"
                    @row-click="roleRowClick"
                ></roleTreeTable>
            </div>
            <div class="h100" slot="right">
                    <div class="h100">
                        <el-col
                            :span="12"
                            class="h100"
                            style="border-right: 1px solid #eee"
                        >
                            <menuTree ref="menuTree" @row-click="menuRowClick" :currentRole="currentRole"></menuTree>
                        </el-col>
                        <el-col
                            :span="12"
                            class="h100"
                            style="border-right: 1px solid #eee"
                        >
                            <btnTree ref="btnTree" :currentRole="currentRole"></btnTree>
                        </el-col>
                    </div>
<!--                    <div class="h100" slot="right">
                        <deptTreeTable ref="deptTreeTable" :currentRole="currentRole"></deptTreeTable>
                    </div>-->
            </div>
        </w-split>
    </div>
</template>
<script>
import wSplit from "@/components/split/split";
import wSplitRight from "@/components/split/split";
import roleTreeTable from "./components/role_tree_table";
import menuTree from "./components/menu_tree";
// import menuTree from "./components/menu_tree_bf";
import btnTree from "./components/btn_tree";
import deptTreeTable from "./components/dept_tree_table";
export default {
    name: "",
    components: {
        wSplit,
        wSplitRight,
        roleTreeTable,
        menuTree,
        btnTree,
        deptTreeTable,
    },
    data() {
        return {
            splitValueL: 0.45,
            clickRoleObj: "", //角色点击对象
            clickMenuObj: "", //菜单点击对象

            currentRole: ''
        };
    },
    methods: {
        //角色行点击
        roleRowClick(row) {
            this.clickRoleObj = row;

            // 公共角色还是 私有角色
            this.currentRole = row.roleType

            setTimeout(() => {
                //获取角色菜单信息
                //this.$refs.menuTree.getMenuTreeInfoByRoleId(row);
                this.$refs.menuTree.getMenuTreeInfoPlus(row);

                // this.clickMenuObj = "";
                let btnObj = { roleId: row.id, menuId: "" };
                //查询按钮列表
                this.$refs.btnTree.initMenuBtnInfo(btnObj);

                //查询数据权限信息
                let dataObj = { roleId: row.id, menuId: "" };
                // this.$refs.deptTreeTable.getAuthScopeInfo(dataObj); //角色数据权限
            }, 500);
        },
        //菜单行点击
        menuRowClick(e) {
            if (this.clickRoleObj == "") return;
            this.clickMenuObj = e;
            let obj = { menuId: e.disabled ? "" : e.id, roleId: "" };
            if (this.clickRoleObj != "") obj.roleId = this.clickRoleObj.id;

            //查询按钮列表
            this.$refs.btnTree.initMenuBtnInfo(obj);

            //数据权限
            // this.$refs.deptTreeTable.getAuthScopeInfo(obj); //角色数据权限
        },
    },
};
</script>
<style lang="less"></style>
